<template></template>

<script>
import Store from '@/store/computed/storeHelpers'
import UserSettingsService from '@/services/requests/userSettings'
export default {
  methods: {
    setInitialSettings() {
      var userSettings = this.$store.state.user.userSettings
      if (!!userSettings.billingPeriod) {
        this.billingPeriod = userSettings.billingPeriod
      }
      if (!!userSettings.projectId) {
        this.projectId = userSettings.projectId
      }
      if (!!userSettings.siteId) {
        this.siteId = userSettings.siteId
      }
      if (!!userSettings.selectedUserId) {
        this.selectedUserId = userSettings.selectedUserId
      }
      if (!!userSettings.tripDefaultHeaders) {
        this.tripDefaultHeaders = JSON.parse(userSettings.tripDefaultHeaders)
      }
      if (!!userSettings.rateDefaultHeaders) {
        this.rateDefaultHeaders = JSON.parse(userSettings.rateDefaultHeaders)
      }
      if (!!userSettings.billDefaultHeaders) {
        this.billDefaultHeaders = JSON.parse(userSettings.billDefaultHeaders)
      }
      if (!!userSettings.rctiDefaultHeaders) {
        this.rctiDefaultHeaders = JSON.parse(userSettings.rctiDefaultHeaders)
      }
      if (!!userSettings.allocationDefaultHeaders) {
        this.allocationDefaultHeaders = JSON.parse(
          userSettings.allocationDefaultHeaders
        )
      }
      if (!!userSettings.tippingDefaultHeaders) {
        this.tippingDefaultHeaders = JSON.parse(
          userSettings.tippingDefaultHeaders
        )
      }
      if (!!userSettings.complianceDefaultHeaders) {
        this.complianceDefaultHeaders = JSON.parse(
          userSettings.complianceDefaultHeaders
        )
      }
      if (!!userSettings.approvedBillLineDefaultHeaders) {
        this.approvedBillLineDefaultHeaders = JSON.parse(
          userSettings.approvedBillLineDefaultHeaders
        )
      }
    },
    changeSetting(field, value) {
      if (field == 'tripDefaultHeaders') {
        value = JSON.stringify(value)
      }
      if (field == 'rateDefaultHeaders') {
        value = JSON.stringify(value)
      }
      if (field == 'billDefaultHeaders') {
        value = JSON.stringify(value)
      }
      if (field == 'rctiDefaultHeaders') {
        value = JSON.stringify(value)
      }
      if (field == 'allocationDefaultHeaders') {
        value = JSON.stringify(value)
      }
      if (field == 'tippingDefaultHeaders') {
        value = JSON.stringify(value)
      }
      if (field == 'complianceDefaultHeaders') {
        value = JSON.stringify(value)
      }
      if (field == 'approvedBillLineDefaultHeaders') {
        value = JSON.stringify(value)
      }

      UserSettingsService.updateSetting({ field: field, value: value })
        .then(result => {
          //console.log(result);
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  computed: {
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    tripDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'tripDefaultHeaders'
    }),
    rateDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'rateDefaultHeaders'
    }),
    billDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'billDefaultHeaders'
    }),
    rctiDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'rctiDefaultHeaders'
    }),
    allocationDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'allocationDefaultHeaders'
    }),
    tippingDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'tippingDefaultHeaders'
    }),
    complianceDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'complianceDefaultHeaders'
    }),
    approvedBillLineDefaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'approvedBillLineDefaultHeaders'
    })
  },
  watch: {
    billingPeriod(val) {
      this.changeSetting('billingPeriod', val)
    },
    projectId(val) {
      this.changeSetting('projectId', val)
    },
    siteId(val) {
      this.changeSetting('siteId', val)
    },
    selectedUserId(val) {
      this.changeSetting('selectedUserId', val)
    },
    tripDefaultHeaders(val) {
      this.changeSetting('tripDefaultHeaders', val)
    },
    rateDefaultHeaders(val) {
      this.changeSetting('rateDefaultHeaders', val)
    },
    billDefaultHeaders(val) {
      this.changeSetting('billDefaultHeaders', val)
    },
    rctiDefaultHeaders(val) {
      this.changeSetting('rctiDefaultHeaders', val)
    },
    allocationDefaultHeaders(val) {
      this.changeSetting('allocationDefaultHeaders', val)
    },
    tippingDefaultHeaders(val) {
      this.changeSetting('tippingDefaultHeaders', val)
    },
    complianceDefaultHeaders(val) {
      this.changeSetting('complianceDefaultHeaders', val)
    },
    approvedBillLineDefaultHeaders(val) {
      this.changeSetting('approvedBillLineDefaultHeaders', val)
    }
  },
  mounted() {
    this.setInitialSettings()
  }
}
</script>

<style>
</style>
